import {LearningTestimonialType} from '@udemy/react-discovery-units';

export const OVERVIEW_TESTIMONIALS = [
    {
        id: '1',
        content:
            'Udemy was truly a game-changer and a great guide for me as we brought Dimensional to life.',
        relatedUrl: '',
        relatedUrlText: '',
        source: {
            description: 'Technical Co-Founder, CTO at Dimensional',
            image: 'https://s.udemycdn.com/home/ub-case-studies/Alvin_Lim.jpeg',
            name: 'Alvin Lim',
        },
        type: LearningTestimonialType.CourseReview,
    },
    {
        id: '2',
        content:
            'Udemy gives you the ability to be persistent. I learned exactly what I needed to know in the real world. It helped me sell myself to get a new role.',
        relatedUrl: '',
        relatedUrlText: '',
        source: {
            description: 'Partner Account Manager at Amazon Web Services',
            image: 'https://s.udemycdn.com/home/ub-case-studies/William_A_Wachlin.jpeg',
            name: 'William Wachlin',
        },
        type: LearningTestimonialType.CourseReview,
    },
    {
        id: '3',
        content:
            "Udemy was rated the most popular online course or certification program for learning how to code according to <a href='https://survey.stackoverflow.co/2023/#section-learning-to-code-online-course-platforms-to-learn-how-to-code'>StackOverflow’s 2023 Developer survey</a>.",
        relatedUrl: '',
        relatedUrlText: '',
        source: {
            description: '37,076 responses collected',
            image: 'https://s.udemycdn.com/home/ub-case-studies/logo_stackoverflow.svg',
            name: 'StackOverflow',
        },
        type: LearningTestimonialType.ThirdParty,
    },
];
